import type { GetRecommendationsRequest } from '@kimuno/api-sdk';

import api from '../clients/api';
import { handleUnauthorized } from '../utils/apiWrapper';
import { notifyBugsnagNetwork } from '../utils/bugsnagClient';

const recommendations = {
	getRecommendations,
};

function getRecommendations(request: GetRecommendationsRequest) {
	notifyBugsnagNetwork('recommendations', 'getRecommendations', { request });
	return handleUnauthorized(() => api.recommendations.getRecommendations(request));
}

export default recommendations;
